import React from "react";
import { Box, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
// components
import ErrorText from "../../../components/ErrorText";
import { ShimmerComponent } from "../../../components/Shimmer/ShimmerComponent";
import BouncingLogo from "../../../components/Shimmer/BouncingLogo";
import SelectDropdown from "../../../components/SelectDropdown";
import NoData from "../../../components/NoData";
import Table from "../../../components/Table";
// hooks
import { useActualVsBudgetHook } from "../hooks/useActualVsBudgetHook";
// constants
import { ACTUAL_VS_BUDGET_BRANCH_TOTAL_MONTHLY_FILE, ACTUAL_VS_BUDGET_BRANCH_TOTAL_WEEKLY_FILE, ACTUAL_VS_BUDGET_BRANCHES_MONTHLY, ACTUAL_VS_BUDGET_BRANCHES_WEEKLY, ACTUAL_VS_BUDGET_CHANNEL_MONTHLY_FILE, ACTUAL_VS_BUDGET_CHANNEL_WEEKLY_FILE, ACTUAL_VS_BUDGET_MONTHLY, ACTUAL_VS_BUDGET_WEEKLY, STICKY_COLUMNS_COLUMN, VIEW_TYPE_MONTHLY } from "../constants";
import ReportDownloadComponent from "../../../components/DownloadReport/ReportDownloadComponent";
// services
import { overrideStoreIdFilterForSelectedBranches } from "../services/ActualVsBudgetServices";

const ActualVsBudget = _ => {
    const { userStores, options, isLoading, error, initialLoading, tableData, handleStoreIdChange, handleResetForStore, resetStore,
        viewType, handleViewChange, filterSelectedChannels, filteredData, selectedChannels, channels, filterSelectedBranches,
        selectedBranches, branchTableData, isTimeoutInProcess, setIsActualVsBudgetBranchesReportLoading, isActualVsBudgetBranchesReportLoading, actualVsBudgetFiltersBranches,
        actualVsBudgetFiltersChannels, isActualVsBudgetChannelReportLoading, setIsActualVsBudgetChannelReportLoading
    } = useActualVsBudgetHook();
    const isDataLoading = isLoading?.channelTableLoading || isLoading?.branchTableLoading;
    const backgroundLoadingStyle = isDataLoading ? '#e4e4e7' : '#fafafa';
    const colorLoadingStyle = isDataLoading ? '#a9a9ab' : 'black';

    return ((userStores?.length > 0) ? (
        <div style={{ height: '88vh', overflow: 'scroll', padding: '70px', paddingBottom: '100px', paddingTop: '24px' }}>
            <div style={{ width: 'fitContent', marginBottom: '20px' }}>
                <div
                    style={{
                        width: '100%',
                        textAlign: 'left',
                        margin: 'auto',
                        fontSize: '1.5rem',
                        fontWeight: '500',
                        lineHeight: '1.6',
                    }}
                >
                    Actual Vs Budget Spend
                </div>
            </div>
            <div style={{ boxSizing: "border-box", display: 'flex', alignItems: 'center', justifyContent: "flex-end", gap: "12px", width: "100%" }}>
                {!initialLoading?.current ?
                    <ToggleButtonGroup
                        value={viewType}
                        exclusive
                        onChange={handleViewChange}
                        aaria-label="Toggle Spends And Opps Table View"
                        disabled={isDataLoading}
                    >
                        <ToggleButton
                            value={'Weekly'}
                            style={{
                                background: viewType === 'Weekly' ? 'black' : backgroundLoadingStyle,
                                color: viewType === 'Weekly' ? 'white' : colorLoadingStyle,
                                borderColor: isDataLoading ? '#a9a9ab' : 'black',
                                textTransform: 'capitalize',
                                height: '40px'
                            }}
                        >
                            Weekly
                        </ToggleButton>
                        <ToggleButton
                            value="Monthly"
                            style={{
                                background: viewType === VIEW_TYPE_MONTHLY ? 'black' : backgroundLoadingStyle,
                                color: viewType === VIEW_TYPE_MONTHLY ? 'white' : colorLoadingStyle,
                                borderColor: isDataLoading ? '#a9a9ab' : 'black',
                                textTransform: 'capitalize',
                                height: '40px'
                            }}
                        >Monthly
                        </ToggleButton>
                    </ToggleButtonGroup> : <ShimmerComponent updatedStyle={{ width: '140px', height: '40px' }} />}
            </div>

            {/* UI for table One  */}
            <div style={{ width: '100%', margin: 'auto', padding: '0px 0px' }}>
                <Typography variant="h6" align='left' sx={{ paddingBottom: '8px' }}>Actual vs Budget - Branch Totals</Typography>
                <div style={{ marginRight: "auto", display: 'flex', flexDirection: 'row', gap: '16px' }}>
                    {!initialLoading?.current ?
                        <SelectDropdown
                            options={options}
                            label={'Select Branch'}
                            isSelectAll={true}
                            allOptionsSelectedText={'All Branches'}
                            multiple={true}
                            multiSelectDefaultValues={options && [...options.map(branch => branch?.value)]}
                            handleFilterChange={filterSelectedBranches}
                            resetValues={resetStore}
                            width={"200px"}
                            marginExist={false}
                            disabled={isLoading?.branchTableLoading}
                        /> : <ShimmerComponent updatedStyle={{ width: '200px' }} />}

                    <div style={{ boxSizing: "border-box", display: 'flex', alignItems: 'center', justifyContent: "flex-end", gap: "12px", width: "100%" }}>
                        {!initialLoading?.current ?
                            <ReportDownloadComponent
                                component={viewType === VIEW_TYPE_MONTHLY ? ACTUAL_VS_BUDGET_BRANCHES_MONTHLY : ACTUAL_VS_BUDGET_BRANCHES_WEEKLY}
                                appliedFilters={overrideStoreIdFilterForSelectedBranches(actualVsBudgetFiltersBranches, selectedBranches, options)}
                                filename={viewType === VIEW_TYPE_MONTHLY ? ACTUAL_VS_BUDGET_BRANCH_TOTAL_MONTHLY_FILE : ACTUAL_VS_BUDGET_BRANCH_TOTAL_WEEKLY_FILE}
                                setIsDownloading={setIsActualVsBudgetBranchesReportLoading}
                                isDownloading={isActualVsBudgetBranchesReportLoading}
                                disabled={isLoading?.branchTableLoading || branchTableData?.rowData?.length === 0 || branchTableData?.rowData?.length > 0 && !selectedBranches?.length || error?.branchTableError || (selectedBranches?.length > 0 && branchTableData?.filteredData?.length === 0)}
                                customButtonStyle={{ marginTop: "8px" }}
                            /> : <ShimmerComponent updatedStyle={{ width: '64px' }} />}
                    </div>
                </div>

                {initialLoading?.current || isLoading?.branchTableLoading ? (
                    <ShimmerComponent updatedStyle={{ width: '100%', height: '100%', backgroundSize: '2000px 800px', border: '0px' }} >
                        <BouncingLogo height='72vh' text='Loading...' />
                    </ShimmerComponent>) : <>
                    {branchTableData?.rowData?.length > 0 && selectedBranches?.length ? <Table
                        boldHeaders={true}
                        boldDataColumns={["branch", "ytd_spend_to_plan", '_YTD']}
                        stickyColumns={STICKY_COLUMNS_COLUMN}
                        data={selectedBranches?.length ? branchTableData?.filteredData : branchTableData?.rowData}
                        columns={branchTableData?.columnData}
                        getCellProps={cellInfo => {
                            if ([`${branchTableData?.columnData?.[2].accessor}`]?.includes(cellInfo.column.id)) {
                                return { style: { backgroundColor: '#FEFBC7' } }
                            } else { return { style: {} } }
                        }}
                    /> : null}

                    {branchTableData?.rowData?.length === 0 && <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '400px' }}>
                        <NoData textValue='No data available' />
                    </Box>}

                    {branchTableData?.rowData?.length > 0 && !selectedBranches?.length && <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '400px' }}>
                        <NoData textValue='No branches selected' />
                    </Box>}

                    {error?.branchTableError && (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '400px' }}>
                            <NoData textValue='Error loading data' />
                        </Box>
                    )}
                </>}
            </div>

            {/* UI for table Two  */}
            <div style={{ width: '100%', margin: 'auto', padding: '0px 0px' }}>
                <Typography variant="h6" align='left' sx={{ paddingBottom: '8px' }}>Actual vs Budget Channel</Typography>
                <div style={{ marginRight: "auto", display: 'flex', flexDirection: 'row', gap: '16px' }}>
                    {!initialLoading?.current ?
                        <SelectDropdown
                            options={options}
                            label={"Select Branch"}
                            resetValues={resetStore}
                            handleResetValues={handleResetForStore}
                            singleSelectDefaultValue={options?.[0]?.value}
                            width={'200px'}
                            handleFilterChange={handleStoreIdChange}
                            marginExist={false}
                            disabled={isLoading?.channelTableLoading}
                        /> : <ShimmerComponent updatedStyle={{ width: '200px' }} />}

                    {!initialLoading?.current && channels?.length ?
                        <SelectDropdown
                            options={channels}
                            label={'Select Channel'}
                            isSelectAll={true}
                            allOptionsSelectedText={'All Channels'}
                            multiple={true}
                            multiSelectDefaultValues={channels && [...channels.map(channel => channel?.value)]}
                            handleFilterChange={filterSelectedChannels}
                            resetValues={resetStore}
                            width={"200px"}
                            marginExist={false}
                            disabled={isLoading?.channelTableLoading}
                        /> : <ShimmerComponent updatedStyle={{ width: '200px' }} />}

                    <div style={{ boxSizing: "border-box", display: 'flex', alignItems: 'center', justifyContent: "flex-end", gap: "12px", width: "100%" }}>
                        {!initialLoading?.current && channels?.length ?
                            <ReportDownloadComponent
                                component={viewType === VIEW_TYPE_MONTHLY ? ACTUAL_VS_BUDGET_MONTHLY : ACTUAL_VS_BUDGET_WEEKLY}
                                appliedFilters={actualVsBudgetFiltersChannels}
                                filename={viewType === VIEW_TYPE_MONTHLY ? ACTUAL_VS_BUDGET_CHANNEL_MONTHLY_FILE : ACTUAL_VS_BUDGET_CHANNEL_WEEKLY_FILE}
                                setIsDownloading={setIsActualVsBudgetChannelReportLoading}
                                isDownloading={isActualVsBudgetChannelReportLoading}
                                disabled={isLoading?.channelTableLoading || isTimeoutInProcess || tableData?.rowData?.length > 0 && !selectedChannels?.length || tableData?.rowData?.length === 0 && selectedChannels?.length || tableData?.rowData?.length === 1 && !error?.channelTableError}
                                customButtonStyle={{ marginTop: "8px" }}
                                multiComponentPayload
                            /> : <ShimmerComponent updatedStyle={{ width: '64px' }} />}
                    </div>
                </div>
                {initialLoading?.current || isLoading?.channelTableLoading || isTimeoutInProcess ? (
                    <ShimmerComponent updatedStyle={{ width: '100%', height: '100%', backgroundSize: '2000px 800px', border: '0px' }} >
                        <BouncingLogo height='72vh' text={isTimeoutInProcess ? 'Channel Selection in process' : 'Loading data...'} />
                    </ShimmerComponent>) : <>
                    {tableData?.rowData?.length > 1 && selectedChannels?.length > 0 && <Table
                        boldHeaders={true}
                        boldDataColumns={["channel"]}
                        stickyColumns={STICKY_COLUMNS_COLUMN}
                        data={filteredData?.length > 0 ? filteredData : tableData?.rowData}
                        columns={tableData?.columnData}
                        getCellProps={cellInfo => {
                            if ([`${tableData?.columnData?.[2].accessor}`]?.includes(cellInfo.column.id)) {
                                return { style: { backgroundColor: '#FEFBC7' } }
                            } else { return { style: {} } }
                        }}
                    />}
                    {tableData?.rowData?.length === 1 && !error?.channelTableError && <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '400px' }}>
                        <NoData textValue='No data available' />
                    </Box>}

                    {tableData?.rowData?.length > 0 && !selectedChannels?.length && <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '400px' }}>
                        <NoData textValue='No channels selected' />
                    </Box>}

                    {tableData?.rowData?.length === 0 && selectedChannels?.length > 0 && <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '400px' }}>
                        <NoData textValue='No data available for selected channel' />
                    </Box>}

                    {error?.channelTableError && (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '400px' }}>
                            <NoData textValue='Error loading data' />
                        </Box>
                    )}
                </>}
            </div>
        </div>
    ) :
        <div style={{ height: '88vh', overflow: 'scroll', padding: '24px', paddingBottom: '100px' }}>
            <div style={{ width: 'fitContent', marginBottom: '55px' }}>
                <div
                    style={{
                        width: '90%',
                        textAlign: 'left',
                        margin: 'auto',
                        fontSize: '1.5rem',
                        fontWeight: '500',
                        lineHeight: '1.6'
                    }}
                >
                    <ErrorText reason='No branches assigned to user' />
                </div>
            </div>
        </div>
    )
};

export default ActualVsBudget;